export enum AuctionStatus {
  New = 0,
  EndingSoon = 1,
  ExpiringToday = 2,
  Closed = 3,
  Canceled = 4,
  Completed = 5,
  Pending = 6,
  Won = 7,
  Lost = 8,
}

export type AddressDetailsType = {
  city: string;
  country: string;
  latitude?: number;
  longitude?: number;
  state: string;
  zip: string;
};
